import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useState } from 'react';
import { Button, Icon } from 'semantic-ui-react';
import _isEmpty from 'lodash/isEmpty';
import { getSelectedModifierIds, transformModifierSetsToLegacyFormat, transformModifiersToLegacyFormat, transformVariationsToLegacyFormat, updateCartItem } from './CartItemEditButton.utils';
import MenuItemCartModal from '../../../../../../../organisms/MenuItemCartModal';
import { CartItemPropType } from '../../../../CartSummary.propTypes';
import './CartItemEditButton.css';
var defaultProps = {
  loading: false
};
function CartItemEditButton(_ref) {
  var item = _ref.item,
    onUpdate = _ref.onUpdate,
    getOrderItemOptions = _ref.getOrderItemOptions,
    loading = _ref.loading;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    displayModal = _useState2[0],
    setDisplayModal = _useState2[1];
  var _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    options = _useState4[0],
    setOptions = _useState4[1];
  var itemUuid = item.uuid;
  function showModal() {
    return _showModal.apply(this, arguments);
  }
  function _showModal() {
    _showModal = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _yield$getOrderItemOp, newOptions;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getOrderItemOptions(itemUuid);
          case 2:
            _yield$getOrderItemOp = _context.sent;
            newOptions = _yield$getOrderItemOp.options;
            setOptions(newOptions);
            setDisplayModal(true);
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _showModal.apply(this, arguments);
  }
  function closeModal() {
    setDisplayModal(false);
    setOptions({});
  }
  function updateItem(_x) {
    return _updateItem.apply(this, arguments);
  }
  function _updateItem() {
    _updateItem = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(newItem) {
      var cartItem;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            cartItem = updateCartItem(item, newItem);
            _context2.next = 3;
            return onUpdate(cartItem);
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return _updateItem.apply(this, arguments);
  }
  var _item$item_data = item.item_data,
    itemId = _item$item_data.object_id,
    name = _item$item_data.name,
    description = _item$item_data.description,
    selectedVariationId = item.item_variation_data.object_id,
    quantity = item.quantity,
    _item$instructions = item.instructions,
    specialInstructions = _item$instructions === void 0 ? '' : _item$instructions;
  var selectedModifiersIds = getSelectedModifierIds(item);
  var _options$variations = options.variations,
    variationOptions = _options$variations === void 0 ? [] : _options$variations,
    _options$modifiers = options.modifiers,
    modifierOptions = _options$modifiers === void 0 ? [] : _options$modifiers,
    _options$modifier_set = options.modifier_sets,
    modifierSetOptions = _options$modifier_set === void 0 ? [] : _options$modifier_set;
  var legacyFormatVariations = transformVariationsToLegacyFormat(variationOptions);
  var legacyFormatModifiers = transformModifiersToLegacyFormat(modifierOptions);
  var legacyFormatModifierSets = transformModifierSetsToLegacyFormat(modifierSetOptions, modifierOptions);
  var catalogItem = {
    _id: itemId,
    modifierSets: modifierSetOptions.map(function (_ref2) {
      var objectId = _ref2.object_id;
      return objectId;
    }),
    name: name,
    description: description,
    variations: legacyFormatVariations
  };
  var selectedVariation = legacyFormatVariations.find(function (_ref3) {
    var id = _ref3._id;
    return id === selectedVariationId;
  });
  var selectedModifiers = legacyFormatModifiers.filter(function (_ref4) {
    var id = _ref4._id;
    return selectedModifiersIds.includes(id);
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "cart-item-edit-button-container"
  }, /*#__PURE__*/React.createElement(Button, {
    icon: true,
    onClick: showModal,
    disabled: loading,
    loading: loading
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "pencil"
  })), displayModal && !_isEmpty(options) && /*#__PURE__*/React.createElement(MenuItemCartModal, {
    type: "update",
    open: displayModal,
    onClose: closeModal,
    item: catalogItem,
    modifiers: legacyFormatModifiers,
    modifierSets: legacyFormatModifierSets,
    variations: legacyFormatVariations,
    cart: {
      getItemIndex: function getItemIndex() {
        return -1;
      },
      updateItem: updateItem,
      isOpen: true
    },
    initialSelectedVariation: selectedVariation,
    initialSelectedModifiers: selectedModifiers,
    initialSpecialInstructions: specialInstructions,
    initialQuantity: quantity,
    loading: loading
  }));
}
CartItemEditButton.defaultProps = defaultProps;
export default CartItemEditButton;